import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable, Optional } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CheckoutObject } from '../../models/checkout';

export interface GlobalPaymentLink {
  clientReferenceId: string;
  configId: string;
  createdAt: string; 
  globalPaymentsReferenceId: string ;
  globalPaymentsUrl: string;
  orderContextId: string;
  status: string; 
  updatedAt: string;
}

@Injectable({
  providedIn: 'root'
})
export class GlobalPaymentsService {

  protected httpClient = inject(HttpClient);

 constructor(
    @Optional()
    @Inject('environment')
    protected environment: { [s: string]: any }
  ) {}


  public isEnabled(): Observable<boolean> {
    return of(this.environment.globalPaymentEnabled || false);
  }

  postOrderToCreateUrl(checkout: CheckoutObject): Observable<GlobalPaymentLink>{
    const url = 'json/globalpayments/links';
    return this.httpClient.post<GlobalPaymentLink>(url, checkout);
  }

  /**
   * validate something in checkout to use or not global Payment
   * @param checkout object
   * @returns true or false if you want use Global Payment (true by default, this is only run if isEnabled() is true)
   */
  shouldUseGlobalPayment(checkout: CheckoutObject): Observable<boolean>{
    return of(true);
  }
}
